const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** URL params can be a UUID (old links) or a friendly handle (slug / username). */
export function isUuid(value: string | null | undefined): boolean {
  return !!value && UUID_RE.test(value);
}
